import * as React from "react";
import { useContext } from "react";
import { toast } from "react-toastify";
import { EditProjectContext } from "../../EditProjectContext";
import { RouteEditTab } from "../../RouteEditTab";
import { isFinished } from "../InboundTab/IsFinished";
import { confirm } from "../../../../Layout/Dialog/ConfirmDialog";
import SaveProject from "../../SaveProject";
import { ProjectState } from "../../../ViewModel/ProjectState";
import { LeftSideLeftGapSpan } from "../Cards/Card";
import DeleteIcon from "../InboundTab/SpdrDelete/DeleteIcon";
import RemovePdsrCommand from "./RemovePdsrCommand";
import { PdsrCardProps } from "./PdsrCard";
import { SpdrPdsrDeleteProps } from "../Cards/CardDeletionProps";

type Props = {
  disabled: boolean;
};

export function PdsrDelete({
  pdsr,
  noDeletionProcessCurrentlyRunning,
  setNoDeletionProcessCurrentlyRunning,
  disabled,
}: PdsrCardProps & SpdrPdsrDeleteProps & Props) {
  const { project, routeEditTabSelected, setSelectedLtlSpdrOrPdsr, reloadData } =
    useContext(EditProjectContext);

  const pdsrId = pdsr?.PdsrId || 0;
  const $hasDeleteButton = routeEditTabSelected === RouteEditTab.Ftl && !disabled;
  const $isFinished = isFinished(project, pdsrId);

  const onDeleteClick = async () => {
    const isConfirmed = await confirm(
      "Do you want to remove the PDSR from current project with all connected routes and pdsrs?"
    );
    if (!isConfirmed) {
      return;
    }

    setNoDeletionProcessCurrentlyRunning(false);
    await SaveProject({ project });
    await toast.promise(RemovePdsrCommand(project.ProjectId || -1, pdsrId), {
      pending: "Deleting pdsr",
      success: "Pdsr was successfully deleted",
      error: "Error occurred while deleting Pdsr",
    });
    await reloadData();
    setNoDeletionProcessCurrentlyRunning(true);
    setSelectedLtlSpdrOrPdsr(undefined);
  };

  if (project.State !== ProjectState.Sandbox) {
    return <span />;
  }

  return (
    <LeftSideLeftGapSpan style={{ visibility: $hasDeleteButton ? "visible" : "hidden" }}>
      <DeleteIcon
        $isFinished={$isFinished}
        deletionAllowed={noDeletionProcessCurrentlyRunning}
        onClick={() => noDeletionProcessCurrentlyRunning && onDeleteClick()}
      />
    </LeftSideLeftGapSpan>
  );
}
